var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.273,
    height: 19.675,
    viewBox: "0 0 17.273 19.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-filter",
    transform: "translate(15874.35 23329.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.657,19.675a2.661,2.661,0,0,1-1.284-.333,2.493,2.493,0,0,1-1.3-2.2v-4.9a2.9,2.9,0,0,0-.591-1.506L1.025,7.085A3.707,3.707,0,0,1,0,4.757V2.633A2.56,2.56,0,0,1,2.54,0H14.733a2.539,2.539,0,0,1,2.54,2.54V4.572a4.157,4.157,0,0,1-1.127,2.614l-4,3.538a2.327,2.327,0,0,0-.693,1.607V16.3a2.736,2.736,0,0,1-1.164,2.161l-1.275.822A2.568,2.568,0,0,1,7.657,19.675ZM2.54,1.386A1.189,1.189,0,0,0,1.386,2.633V4.757a2.416,2.416,0,0,0,.628,1.358l3.519,3.7a4.232,4.232,0,0,1,.933,2.42v4.9a1.1,1.1,0,0,0,.591.988,1.222,1.222,0,0,0,1.219-.009l1.284-.822a1.393,1.393,0,0,0,.517-.988V12.331a3.679,3.679,0,0,1,1.173-2.66L15.2,6.17A2.756,2.756,0,0,0,15.9,4.563V2.54a1.155,1.155,0,0,0-1.155-1.155Z",
    transform: "translate(-15874.35 -23329.65)",
    fill: "#061133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/Icon-filter.f20f091e04884182c786d10e0d49d24c.svg";
export { ForwardRef as ReactComponent };